const type = {
  SELF: 0,
  PDD: 1
};

export default type;
